/**
 * Config Options for the Map and Marker components
 */
const svgMarker =
    '<svg width="31" height="44" viewBox="0 0 31 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1775 0.666626C6.82323 0.666626 0.0664062 7.34396 0.0664062 15.6C0.0664062 26.8 15.1775 43.3333 15.1775 43.3333C15.1775 43.3333 30.2886 26.8 30.2886 15.6C30.2886 7.34396 23.5318 0.666626 15.1775 0.666626ZM15.1775 20.9333C12.1985 20.9333 9.78069 18.5439 9.78069 15.5999C9.78069 12.6559 12.1985 10.2666 15.1775 10.2666C18.1566 10.2666 20.5743 12.6559 20.5743 15.5999C20.5743 18.5439 18.1566 20.9333 15.1775 20.9333Z" fill="#3659E3"/></svg>';
export const markerOptions: google.maps.MarkerOptions = {
    icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgMarker),
};
export const mapOptions: google.maps.MapOptions = {
    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f5f5f5',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text',
            stylers: [
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    lightness: '-11',
                },
            ],
        },
        {
            featureType: 'administrative.neighborhood',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f5f5f5',
                },
                {
                    lightness: '-1',
                },
            ],
        },
        {
            featureType: 'landscape.natural.terrain',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    color: '#ffffff',
                },
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    lightness: '0',
                },
                {
                    hue: '#ff6500',
                },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    color: '#ffffff',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#ffffff',
                },
                {
                    lightness: '0',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: '28',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    hue: '#007bff',
                },
                {
                    saturation: 30,
                },
                {
                    lightness: 49,
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#39c2c9',
                },
                {
                    saturation: '-20',
                },
                {
                    gamma: '1.00',
                },
                {
                    lightness: '46',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
    ],
    mapTypeControl: false,
    minZoom: 7,
    maxZoom: 18,
};
